export default "__VITE_ASSET__BJVIP9gJ__"